import { useConnectedClient } from 'context/ConnectedClientContext';
import { teamUtils } from 'lib/teams';

export const useIsGuest = () => {
  const { details } = useConnectedClient();

  return teamUtils.isGuestByRoleId(details?.teamRole);
};
